import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'

interface PageBodyProps {
  children: ReactNode
  className?: string
}

/**
 * Тело страницы раздела: своя скролл-область и ширина читаемости. Строка списка
 * на широком мониторе иначе растягивается во всю ширину, и правый край (гид,
 * занятость, действия) теряет связь с именем в левом.
 *
 * Ширина одна на все разделы: заголовок обязан стоять на той же вертикали при
 * переходе между ними, иначе он прыгает по горизонтали от раздела к разделу.
 * Где нужен более узкий текст (настройки), сужается содержимое, а не тело.
 */
export function PageBody({ children, className }: PageBodyProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
      <div
        className={cn('mx-auto flex w-full max-w-5xl flex-1 flex-col px-4 py-5 sm:px-6', className)}
      >
        {children}
      </div>
    </div>
  )
}
